import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import RouterService from '@ember/routing/router-service';
import SegmentModel from 'cio/models/segment';

export default class NewSegmentController extends Controller {
  @service router!: RouterService;

  declare model: SegmentModel;

  queryParams = ['referenceSegmentId'];

  @tracked referenceSegmentId = null;

  setDefaults() {
    this.referenceSegmentId = null;
  }

  saveSegment = task({ drop: true }, async () => {
    let { model } = this;

    await model.save();

    if (model.isManual) {
      this.router.transitionTo('segments.segment.overview', model.id);
    } else {
      this.router.transitionTo('segments.segment', model.id);
    }
  });

  @action
  resetSegment() {
    this.model.rollbackAttributes();
    this.router.transitionTo('segments');
  }
}
